// extracted by mini-css-extract-plugin
module.exports = {"bottom-slider":"BottomSlider_bottom-slider__2rW8-"};